import IAgeRange from "../interfaces/IAgeRange";

export const AgeRanges: IAgeRange[] = [
    {
        id: "abf9a69c-6214-4653-a040-807ea8951b20",
        name: "Up to (& including) 18 years",
    },
    { id: "444015b0-f19c-4678-9cd8-af1e80827cbb", name: "19 to 25" },
    { id: "e7949315-8188-434d-8c23-9e12475e9dee", name: "26 to 64" },
    { id: "67a2aca2-0d45-4a4c-a7a6-5833d4c586a6", name: "65 or over" },
];
